import styled from "@emotion/styled"
import { RefObject, useState } from "react"
import Form from "./Form"
import FormResult from "./FormResult"

const StyledFromWrapper = styled.div`
  padding-top: 8px;
  width: 100%;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding-bottom: 24px;
    padding-top: 48px;
    padding-bottom: 48px;
  }
  label {
    font-size: 16px;
    color: #051711;
  }
`

const StyledDiv = styled.div`
  background-color: #f5f6f8;
  height: fit-content;
  padding: 16px;
  position: sticky;
  top: 81px;
  ${(p) => p.theme.breakpoints.up("md")} {
    max-width: 381px;
    border: 1px solid #d1d5db;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0px 2px 8px 0px #26303d29;
  }
`

type Props = {
  isDriversPage?: boolean
  formRef: RefObject<HTMLDivElement | null>
  tooltipText: string
}

const StickyForm = ({ isDriversPage, formRef, tooltipText }: Props) => {
  const [submitForm, setSubmitForm] = useState(false)
  const [isFormError, setIsFormError] = useState(false)
  return (
    <StyledFromWrapper ref={formRef}>
      <StyledDiv ref={formRef}>
        {!submitForm ? (
          <Form
            setSubmitForm={setSubmitForm}
            setIsFormError={setIsFormError}
            isDriversPage={isDriversPage}
            tooltipText={tooltipText}
          />
        ) : (
          <FormResult
            isFormError={isFormError}
            setSubmitForm={setSubmitForm}
            setIsFormError={setIsFormError}
          />
        )}
      </StyledDiv>
    </StyledFromWrapper>
  )
}

export default StickyForm
